import { MUI } from 'ci-esi-web-shared';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

type CommonSearchProps = {
  onChange: (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  value: string;
  placeholder?: string;
  shapeFileModal?: boolean;
};
export function CommonSearch({ onChange, value, placeholder = '', shapeFileModal = false }: CommonSearchProps) {
  const { t } = useTranslation();

  return (
    <MUI.Box
      sx={{
        display: 'flex',
        flexDirection: shapeFileModal ? 'row' : 'column',
        width: shapeFileModal ? '400px' : '200px',
        alignItems: shapeFileModal ? 'center' : 'flex-start',
      }}
    >
      <MUI.InputLabel sx={{ marginRight: shapeFileModal ? '10px' : '0px', minWidth: '45px' }}>
        {t(translations.COMMON.SEARCH)}
      </MUI.InputLabel>
      <MUI.TextField hiddenLabel onChange={onChange} value={value} placeholder={placeholder} />
    </MUI.Box>
  );
}
